import React, { useState } from 'react';
import { HiSearch } from 'react-icons/hi';
import { CiFilter } from 'react-icons/ci';
import UserTable from './UserTable';
import Modal from 'react-modal';
import Select from 'react-select';
import { api } from '../../Api-Endpoints/apiEndpoint';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { addUserRequest, addUserSuccess } from '../../Redux/UserSlice';
import { MdDelete } from 'react-icons/md';
import toast from 'react-hot-toast';
import { IoMdCloseCircleOutline } from 'react-icons/io';

const UserListing = () => {
  const dispatch = useDispatch();
  const { user, loggedOrg, isOrgAuth, _roles } = useSelector(
    state => ({
      user: state.User.user,
      loggedOrg: state.Organization.loggedOrg,
      isOrgAuth: state.Organization.isOrgAuth,
      _roles: state.Roles._roles,
    }),
    shallowEqual
  );

  const [isUserModelOpen, setIsUserModelOpen] = useState(false);
  const [isUser, setIsUser] = useState(false);
  const [userInput, setUserInput] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    phone: '',
  });
  const [roles, setRoles] = useState([]);
  const [validations, setValidations] = useState({
    validEmail: true,
    validRole: true,
    validFirstName: true,
    validLastName: true,
    validPhone: true,
    validPassword: true,
  });

  const inputHandle = e => {
    setValidations(prev => ({ ...prev, [e.target.name]: true }));
    const { value, name } = e.target;
    setUserInput(prev => ({ ...prev, [name]: value }));
  };

  const validateFields = () => {
    const { firstName, lastName, email, password, phone } = userInput;
    let isValid = true;

    const newValidations = {
      validFirstName: firstName.trim() !== '',
      validFirstName: lastName.trim() !== '',
      validFirstName: phone.trim() !== '',
      validEmail: /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
      validPassword: password.trim() !== '',
      validRole: roles.length > 0,
    };

    for (let key in newValidations) {
      if (!newValidations[key]) isValid = false;
    }

    setValidations(newValidations);
    return isValid;
  };

  const onSubmitUser = async () => {
    try {
      if (validateFields()) {
        dispatch(addUserRequest());
        userInput._User = user._id;
        userInput.parent = user._id;
        userInput.role = 'user';
        roles.length > 0
          ? (userInput._roles = roles.map(r => r._id))
          : toast.error('Please select a role');
        if (isOrgAuth) {
          userInput.org = loggedOrg._id;
          userInput.parent = loggedOrg._id;
        }

        const { data, status } = await api.post(
          '/user/user-register',
          userInput
        );

        if (status === 201) {
          dispatch(addUserSuccess(data.user));
          setIsUser(!isUser);
          setIsUserModelOpen(false);
          setUserInput({
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            phone: '',
          });
          setRoles([]);
        } else if (data?.success === false) {
          toast.error(data?.msg);
        } else {
          toast.error('Something went wrong');
        }
      } else {
        toast.error('Please fix the validation errors.');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const options = _roles.map(role => ({
    value: role._id,
    label: role.name,
  }));

  // Handle selection change
  const handleChange = selectedOption => {
    setValidations(prev => ({ ...prev, validRole: true }));
    if (selectedOption && selectedOption.value !== 'zero') {
      const selectedRole = _roles.find(
        role => role._id === selectedOption.value
      );
      if (selectedRole) {
        if (roles?.some(role => role == selectedRole)) {
          toast.error('ThisROle already exists');
        }
        setRoles(prev => [...prev, selectedRole]);
      }
    }
  };

  return (
    <>
      <div className="px-1 pt-1 ml-3 space-y-3 ">
        <div className="flex justify-between">
          <div className="flex space-x-3">
            <div className="relative flex items-center w-full overflow-hidden md:w-96 border border-gray-400 rounded-lg px-3">
              <input
                className="w-full h-10 border-none text-sm outline-none bg-transparent"
                type="text"
                id="search"
                placeholder="Search"
              />
              <button className="grid place-items-center h-full w-12 text-gray-300 ">
                <HiSearch className="w-6 h-6 text-gray-400" />
              </button>
            </div>
            <button className="border px-3 py-1 rounded-lg border-gray-400">
              <CiFilter className="w-6 h-6 text-black-400" />
            </button>
          </div>
          <div>
            <button
              onClick={() => setIsUserModelOpen(true)}
              className="h-[100%] w-[10dvw] rounded-md border border-black text-white bg-bgColor"
            >
              Add Users
            </button>
          </div>
        </div>
        <div className="w-full">
          <UserTable isUser={isUser} />
        </div>
      </div>

      <Modal
        isOpen={isUserModelOpen}
        onRequestClose={() => setIsUserModelOpen(false)}
        contentLabel="Example Modal"
        style={{
          content: {
            width: '65%',
            height: '65vh',
            margin: 'auto',
            borderRadius: '20px',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
          },
        }}
      >
        <div className="h-[60dvh] w-[90%] flex flex-col gap-2 m-auto">
          <div className="flex justify-between">
            <h1 className="text-2xl font-semibold">Role Manage</h1>
            <button>
              <IoMdCloseCircleOutline
                size={20}
                onClick={() => setIsUserModelOpen(false)}
              />
            </button>
          </div>
          <hr />
          <div className="h-[10dvh] w-[100%] flex gap-2">
            <div className="h-[100%] w-[50%] flex flex-col gap-2">
              <label>First Name</label>
              <input
                name={'firstName'}
                value={userInput.firstName}
                onChange={inputHandle}
                type="text"
                placeholder="First Name"
                className={`h-[100%] w-[100%] rounded-md border ${
                  validations.validFirstName ? 'border-black' : 'border-red-500'
                }`}
              />
              {!validations.validFirstName && (
                <span className="text-red-500 text-sm">
                  First name is required
                </span>
              )}
            </div>
            <div className="h-[100%] w-[50%] flex flex-col gap-2">
              <label>Last Name</label>
              <input
                name={'lastName'}
                value={userInput.lastName}
                onChange={inputHandle}
                type="text"
                placeholder="Last Name"
                className={`h-[100%] w-[100%] rounded-md border ${
                  validations.validPassword ? 'border-black' : 'border-red-500'
                }`}
              />
              {!validations.validFirstName && (
                <span className="text-red-500 text-sm">
                  Last name is required
                </span>
              )}
            </div>
          </div>
          <div className="h-[10dvh] w-[100%] flex gap-2">
            <div className="h-[100%] w-[50%] flex flex-col gap-2">
              <label className="">Email</label>
              <input
                name="email"
                value={userInput.email}
                onChange={inputHandle}
                type="email"
                placeholder="Email"
                className={`h-8 w-full rounded-md border ${
                  validations.validEmail ? 'border-black' : 'border-red-500'
                }`}
              />
              {!validations.validEmail && (
                <span className="text-red-500 text-sm">Enter valid email</span>
              )}
            </div>
            <div className="h-[100%] w-[50%] flex flex-col gap-2">
              <label className="">Password</label>
              <input
                name="password"
                value={userInput.password}
                onChange={inputHandle}
                type="password"
                placeholder="Password"
                className={`h-8 w-full rounded-md border ${
                  validations.validPassword ? 'border-black' : 'border-red-500'
                }`}
              />
              {!validations.validPassword && (
                <span className="text-red-500 text-sm">
                  Password is required
                </span>
              )}
            </div>
          </div>
          <div className="h-[10dvh] w-[100%] flex gap-2 ">
            <div className="h-[100%] w-[50%] flex flex-col gap-2">
              <label>Phone</label>
              <input
                name={'phone'}
                value={userInput.phone}
                onChange={inputHandle}
                type="text"
                placeholder="Phone"
                className={`h-[100%] w-[100%] rounded-md border ${
                  validations.validPassword ? 'border-black' : 'border-red-500'
                }`}
              />
              {!validations.validFirstName && (
                <span className="text-red-500 text-sm">
                  Phone Number is required
                </span>
              )}
            </div>
          </div>
          <div className="h-[10dvh] w-[100%] flex gap-2 ">
            <div className="h-[100%] w-[80%] rounded-md">
              <p>
                Assign Role<span className="text-red-500">*</span>
              </p>
              <Select
                options={[
                  { value: 'zero', label: '--select role--' },
                  ...options,
                ]}
                onChange={handleChange}
                placeholder="--select role--"
                isSearchable
              />
              {!validations.validRole && (
                <span className="text-red-500 text-sm">
                  Select role to proceed
                </span>
              )}
            </div>
          </div>
          <div className="h-[50%] w-[80%] rounded-md">
            <h3>Role Selected</h3>
            <div className="w-full h-[200px] bg-purple-100 border-none rounded-lg p-5">
              {roles.map((_pro, _index) => {
                return (
                  <div key={_index} className="flex justify-between">
                    <p>{_pro.name}</p>
                    <MdDelete
                      className="cursor-pointer"
                      onClick={() =>
                        setRoles(roles.filter(r => r._id !== _pro._id))
                      }
                    />
                  </div>
                );
              })}
            </div>
          </div>

          <button
            onClick={onSubmitUser}
            className="h-[5dvh] w-[10dvw] self-start rounded-md border border-black text-white bg-bgColor"
          >
            Save
          </button>
        </div>
      </Modal>
    </>
  );
};

export default UserListing;
